<template>
  <v-rating-modal
    @onHide="onHideModal"
    :loading="loading"
    :show="ratingModalShow"
    :data="ratingData"
  />
</template>

<script>
import ratingApi from '@/api/rating'

export default {
  name: 'RatingNpsCsatVibbra',
  data() {
    return {
      ratingFunctions: ['fetchNPSVibbra', 'fetchCSATVibbra'],
      ratingModalControl: 0,
      ratingData: {},
      ratingRequestParams: {},
      ratingModalShow: false,
      loading: true,
    }
  },
  mounted() {
    const user = this.$store.getters.user
    this[this.ratingFunctions[this.ratingModalControl]](user)
  },
  methods: {
    onHideModal() {
      this.ratingModalShow = false
      this.ratingModalControl += 1
    },
    fetchCSATVibbra(user) {
      ratingApi
        .fetch_csat_vibbra(user)
        .then(response => {
          const { data } = response
          if (data) {
            this.ratingModalShow = true
            this.ratingData = data
          } else {
            this.ratingModalControl += 1
          }
        })
        .finally(() => (this.loading = false))
    },
    fetchNPSVibbra(user) {
      ratingApi
        .fetch_nps_vibbra(user)
        .then(response => {
          const data = response.data
          if (data) {
            this.ratingModalShow = true
            this.ratingData = data
          } else {
            this.ratingModalControl += 1
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    ratingModalControl(newValue) {
      console.log('ratingModalControl watch', newValue)
      if (this.ratingFunctions[newValue]) {
        this[this.ratingFunctions[newValue]](this.$store.getters.user)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/parts/components/rating-nps-csat-vibbra.vue